import React from "react";
import { useSelector } from "react-redux";
import { TextField, TextFieldProps } from "@mui/material";
import { useFormContext } from "react-hook-form";
import CField, { CFieldInputProps } from "$forms/CField";
import CompanySelect from "$forms/CompanySelect";
import { CompanyType } from "$types";
import { useStyles } from "../styles";
import { useProjectForm } from "../context/ProjectFormContext";

import { appState } from "$store";

export const ProjectFormBasicInfo: React.FC = () => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  const classes = useStyles();

  const { project, defaultValuesForm } = useProjectForm();
  const { filter: companySidebarFilter } = useSelector(appState);

  return (
    <>
      <div>
        <CField
          control={control}
          name="company"
          required
          error={errors.company}
          disabled={
            Boolean(project) ||
            companySidebarFilter ||
            defaultValuesForm?.company
          }
        >
          {(props: CFieldInputProps) => (
            <CompanySelect
              {...props}
              rowsPerPage={99999}
              minCharsToTrigerSearch={0}
              companyTypes={[CompanyType.CLIENT]}
              onChange={(data) => {
                props.onChange(data);
                if (data) {
                  setValue("contact", null);
                }
              }}
            />
          )}
        </CField>
      </div>
      <div className={classes.newFormFieldsRow}>
        <div className={classes.newFormFieldsCol}>
          <CField
            control={control}
            label="Code projet"
            name="code"
            rules={{
              pattern: {
                value:
                  /^[a-zA-Z0-9-/\\(\\)\\\\{\\}\\\\^\\$\\|\\?\\*\\+\\.\\<\\>\\-\\=\\!\\_àâêéèïôöùñ]*$/i,
                message: "Veuillez entrer un code valide",
              },
            }}
            required
            error={errors.code}
          />
        </div>
        <div className={classes.newFormFieldsCol}>
          <CField
            label="Nom du projet"
            control={control}
            name="name"
            required
            error={errors.name}
          />
        </div>
      </div>
      <div className={classes.newFormFieldsRow}>
        <CField
          control={control}
          name="description"
          label="Description"
          error={errors.description}
        >
          {(props: TextFieldProps) => (
            <TextField
              {...props}
              variant="outlined"
              style={{ width: "100%" }}
              multiline
              minRows={3}
            />
          )}
        </CField>
      </div>
    </>
  );
};
